import {
  getCustomerProfileDetailsActions,
  getCustomerProfileDetailsServiceName
} from '~/src/Redux/Customer/Actions'
import serviceActionCreator from '~/src/Redux/serviceActionCreatorWithTokenRotation'

import { asHttp } from '~/src/Configurations/WebHttp'
import { getRequiredDataForHeaders } from '~/src/utils/global'
import { GALAXY_API_DOMAIN } from '~/src/Configurations/env'

async function getCustomerProfileDetails() {
  const options = {
    url: `${GALAXY_API_DOMAIN}/customer-profile/details`,
    method: 'GET',
    headers: getRequiredDataForHeaders()
  }
  const response = await asHttp.request(options)
  const { data: body } = response
  const { data } = body
  if (!data) {
    const data: any = {}
    data.error = body.error

    return data
  }
  return data
}

const getCustomerProfileDetailsAction = serviceActionCreator(
  getCustomerProfileDetailsActions,
  getCustomerProfileDetails
)

export default getCustomerProfileDetailsAction
export { getCustomerProfileDetailsServiceName }
